import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './Home.css';

gsap.registerPlugin(ScrollTrigger);

const Section1 = () => {
  const textRef = useRef(null);

  useEffect(() => {
    const letters = textRef.current.querySelectorAll('.letter');

    gsap.fromTo(
      letters,
      { y: 50, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        stagger: 0.05,
        duration: 0.6,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: textRef.current,
          start: 'top 80%',   // when the element is 80% from top of viewport
          toggleActions: 'play none none reverse',
        }
      }
    );
  }, []);

  const text = "STOP SPREADING YOUR BUDGET THIN\nSTART PUTTING IT WHERE IT WORKS";
  const lines = text.split('\n');

  return (
    <div className='sectionndiv'>
      <div className='backdiv'>
        <h5 className='quotee_text' ref={textRef}>
          {lines.map((line, lineIndex) => (
            <div key={lineIndex} className="line">
              {line.split('').map((char, i) => (
                <span key={i} className="letter">{char === ' ' ? '\u00A0' : char}</span>
              ))}
            </div>
          ))}
        </h5>
      </div>
    </div>
  );
};

export default Section1;
